module.exports = __webpack_public_path__ + "static/media/setupcardicon.2b1acca2.svg";